import { render, staticRenderFns } from "./CartaoRecorrencia.vue?vue&type=template&id=f4c0d8cc&scoped=true"
import script from "./CartaoRecorrencia.vue?vue&type=script&setup=true&lang=js"
export * from "./CartaoRecorrencia.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CartaoRecorrencia.vue?vue&type=style&index=0&id=f4c0d8cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4c0d8cc",
  null
  
)

export default component.exports